import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const CartPage = () => {
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([]);
  const [phone, setPhone] = useState("");

  // Load cart from localStorage
  useEffect(() => {
    const savedCart = localStorage.getItem("cart");
    if (savedCart) {
      setCartItems(JSON.parse(savedCart));
    }
  }, []);

  // Save updated cart to localStorage
  const updateLocalStorage = (items) => {
    localStorage.setItem("cart", JSON.stringify(items));
    setCartItems(items);
  };

  // Remove individual item
  const removeItem = (id) => {
    const updated = cartItems.filter((item) => item.product_id !== id);
    updateLocalStorage(updated);
  };

  // Clear entire cart
  const clearCart = () => {
    updateLocalStorage([]);
    setPhone("");
  };

  // Calculate total cost
  const total = cartItems.reduce((sum, item) => sum + item.product_cost, 0);

  // Handle payment for total
  const handleTotalPayment = async () => {
    if (!phone || phone.length < 10) {
      alert("Please enter a valid phone number.");
      return;
    }

    try {
      const data = new FormData();
      data.append("phone", phone);
      data.append("amount", total);

      await axios.post(
        "https://mnkymn9n.pythonanywhere.com/api/mpesa_payment",
        data
      );

      alert("✅ Please complete the payment on your phone.");
    } catch (error) {
      alert("❌ Payment failed. Try again.");
      console.error(error);
    }
  };

  return (
    <div className="container mt-5">
      <h2 className="mb-4 text-center">🛒 Your Cart</h2>

      {cartItems.length === 0 ? (
        <div className="alert alert-info text-center">
          Your cart is empty. <br />
          <button className="btn btn-primary mt-3" onClick={() => navigate("/")}>
            Go to Products
          </button>
        </div>
      ) : (
        <>
          {/* Clear Cart Button */}
          <div className="text-end mb-3">
            <button className="btn btn-outline-danger" onClick={clearCart}>
              🧹 Clear Cart
            </button>
          </div>

          {/* Cart Items */}
          <div className="row">
            {cartItems.map((item) => (
              <div key={item.product_id} className="col-md-4 mb-4">
                <div className="card shadow-sm h-100">
                  <img
                    src={`https://mnkymn9n.pythonanywhere.com/static/images/${item.product_photo}`}
                    alt={item.product_name}
                    className="card-img-top"
                    style={{
                      height: "250px",
                      objectFit: "cover",
                      objectPosition: "center",
                      backgroundColor: "#f8f8f8",
                      borderBottom: "1px solid #eee",
                    }}
                  />
                  <div className="card-body d-flex flex-column">
                    <h5>{item.product_name}</h5>
                    <p className="small text-muted">
                      {item.product_description.slice(0, 60)}...
                    </p>
                    <p className="fw-bold text-success">Ksh {item.product_cost}</p>
                    <div className="mt-auto d-flex justify-content-between">
                      <button
                        className="btn btn-outline-danger btn-sm"
                        onClick={() => removeItem(item.product_id)}
                      >
                        Remove
                      </button>
                      <button
                        className="btn btn-success btn-sm"
                        onClick={() =>
                          navigate("/makepayment", { state: { land: item } })
                        }
                      >
                        Pay Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Total & Checkout */}
          <div className="text-end mt-4">
            <h4>
              Total: <span className="text-success">Ksh {total}</span>
            </h4>

            {/* Phone input */}
            <div className="mt-3">
              <input
                type="text"
                className="form-control mb-2"
                placeholder="Enter phone (e.g., 2547XXXXXXXX)"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
              <button
                className="btn btn-primary"
                onClick={handleTotalPayment}
                disabled={!phone}
              >
                💳 Pay Total
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CartPage;
